import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import {
  TrimText,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import {
  TempleList,
  TempleDelete,
  TempleStatusChange,
} from "../../services/temple.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

const ListTemple = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [statsupdate, setStatusUpdate] = useState(false);
  const [globalsearch, setGlobalSearch] = useState("");
  const [list, setList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);

  const queryParams = new URLSearchParams(location.search);
  const devParam = queryParams.get("dev");
  const [isDevMode, setIsDevMode] = useState(devParam === "true");

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Temple"), url: "" },
  ];

  // Fetch temples
  const fetchData = () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("page", page);
    formData.append("per_page", perPage);
    formData.append("global_search", globalsearch);
    formData.append("search", JSON.stringify(search));
    formData.append("sort", JSON.stringify(sorting));

    TempleList(formData)
      .then((data) => {
        setList(data?.data?.list || []);
        setTotalRecords(data?.data?.total_records || 0);
        setDataLength(data?.data?.total_records);
        setPage(data?.data?.page || 1);
        setLoader(false);
      })
      .catch((err) => {
        console.log("Error fetching temples:", err);
        setLoader(false);
      });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData();
    }, 300);
    return () => clearTimeout(timeout);
  }, [globalsearch, search, page, sorting, statsupdate]);

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    setPage(1);
  };

  const prepareSearch = (key, value) => {
    const sr = { ...search };
    if (String(value).length > 0) sr[key] = value;
    else delete sr[key];
    setSearch(sr);
  };

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    const order = e.target.classList.contains("assc") ? -1 : 1;
    setSorting({ column, order });
  };

  const changeStatus = (templeId) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("You are about to change the status of this temple"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("Cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("Confirm"),
    }).then((result) => {
      if (result.isConfirmed) {
        TempleStatusChange({ o_id: templeId })
          .then((response) => {
            setStatusUpdate((prev) => !prev);
            Swal.fire({
              icon: response.success ? "success" : "error",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              text:
                error?.response?.data?.message ||
                error?.message ||
                "Server error, please try again",
              ...SWAL_SETTINGS,
            });
          });
      }
    });
  };

  function Deletefunction(data) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        TempleDelete(data)
          .then((response) => {
            setStatusUpdate(!statsupdate);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  function viewfunction(data) {
    navigate(`/admin/temples/view/${data._id}`);
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />

      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            {/* Filter & Add */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("Temple")}</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>
                <button
                  type="reset"
                  className="btn btn-warning me-2"
                  onClick={resetFilter}
                >
                  {t("btn_reset_filter")}
                </button>
                <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() => navigate("/admin/temples/add")}
                >
                  {t("btn_add_new")}
                </button>
              </div>
            </div>

            {/* Table */}
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th>{t("list_heading_sno")}</th>
                    <th>{t("Temple Name")}</th>
                    <th>{t("Temple Location")}</th>
                    <th>{t("Description")}</th>
                    <th>{t("list_heading_status")}</th>
                    <th>{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={6}>
                        <Loader />
                      </td>
                    </tr>
                  ) : list.length > 0 ? (
                    list.map((temple, i) => (
                      <tr key={temple._id}>
                        <td>{(page - 1) * perPage + i + 1}</td>
                        <td>{TrimText(temple.templeName, 20)}</td>
                        <td>{temple.templeLocation}</td>
                        <td>{TrimText(temple.templeDesc, 30)}</td>
                        <td>
                          <button
                            type="button"
                            className={`btn ripple ${
                              temple.status
                                ? "btn-main-primary signbtn"
                                : "btn-secondary"
                            }`}
                            onClick={() => changeStatus(temple._id)} // <- pass actual status
                          >
                            {temple.status ? t("Active") : t("Inactive")}
                          </button>
                        </td>
                        <td>
                          <button
                            className="btn ripple btn-main-primary signbtn me-2"
                            onClick={() => {
                              viewfunction(temple);
                            }}
                          >
                            {t("btn_view")}
                          </button>
                          <button
                            className="btn btn-success me-2"
                            onClick={() =>
                              navigate(`/admin/temples/edit/${temple._id}`)
                            }
                          >
                            {t("btn_edit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary mlAction"
                            onClick={() => {
                              Deletefunction(temple?._id);
                            }}
                          >
                            {t("btn_delete")}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center">
                        {t("msg_no_records")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "PageTable",
                    path: "/admin/temple/service",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ListTemple;
